import { useMutation, useQueryClient } from '@tanstack/react-query';
import request from '@teetsh/app/src/utils/request';
import { useSchoolSchoolyear } from '@teetsh/app/src/containers/App/context/SchoolyearSchoolProvider';
import { ELEVES_CUSTOM_FIELDS_KEY } from './useElevesCustomFields';
import { ELEVES_VIEWS_KEY } from '@teetsh/app/src/queries/eleves/views/useElevesViews';

function deleteEleveCustomFields(props: {
  schoolyearId: string;
  schoolId: string;
  customFieldId: string;
}) {
  const requestURL = `/schoolyears/${props.schoolyearId}/schools/${props.schoolId}/eleves-custom-fields/${props.customFieldId}`;
  return request(requestURL, {
    method: 'DELETE',
  });
}

export default function useDeleteElevesCustomField() {
  const { schoolyear, school } = useSchoolSchoolyear();
  const queryClient = useQueryClient();

  const { mutateAsync } = useMutation({
    mutationFn: (p: { customFieldId: string }) =>
      deleteEleveCustomFields({
        schoolyearId: schoolyear.id,
        schoolId: school.id,
        customFieldId: p.customFieldId,
      }),

    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [ELEVES_CUSTOM_FIELDS_KEY],
      });
      queryClient.invalidateQueries({
        queryKey: [ELEVES_VIEWS_KEY],
      });
    },
  });
  return mutateAsync;
}
